const bookingRoutes = {
  booking: 'app',
  containers: {
    authentication: 'authentication',
    home: 'home',
    account: 'account',
    locations: 'locations',
    getApp: 'get-app',
    rewardList: 'list',
    dealDetail: 'detail',
    couponDetail: 'coupon',
    rewardProgramDetails: 'program-details',
    referral: 'referral',
    coupons: 'coupons',
    offers: 'offers',
    applyDiscount: 'apply-coupon',
    deleteAccountSuccess: 'delete-account-success',
    aboutUs: 'about-us',
    ordering: 'ordering',
    deals: 'deals',
    helpSupport: 'help-support',
    scan: 'scan',
    vipPassList: 'pass-list',
    vipPassDetail: 'pass-detail',
    vipMembershipList: 'membership-list',
    payment: 'payment',
    myRewards: 'my-rewards',
    payEarn: 'pay-earn',
    bookTable: 'book-table',
    bookings: 'bookings',
    delivery: 'delivery-address',
    selectOutlet: 'select-outlet',
    location: 'location',
    bookService: 'book-service',
    cart: 'cart',
    confirmation: 'confirmation',
    policies: 'policies',
    serviceCatalog: 'service-catalog',
    categoryCatalog: 'categories',
    bookingFeedback: 'booking-feedback',
  },
  authentication: {
    signUp: 'signup',
    signIn: 'signin',
  },
  payEarn: {
    selectBrand: 'select-brand',
    selectOutlet: 'select-outlet',
    enterAmount: 'enter-amount',
    payAmount: 'pay-amount',
    coupons: 'coupons',
    couponDetails: 'couponDetails',
    payment: 'payment',
    confirmation: 'confirmation',
  },
  bookTable: {
    selectBrand: 'select-brand',
    selectOutlet: 'select-outlet',
    selectTable: 'select-table',
    confirmation: 'confirmation',
  },
};

export default bookingRoutes;
